import { Controller } from "@hotwired/stimulus"

declare global {
  interface Window {
    Turbo?: { visit: (url: string, options?: { action?: string }) => void }
  }
}

// 行内のインタラクティブ要素（リンク・ボタン・フォーム要素）のクリックは
// 行ナビゲーションの対象外とし、その要素本来の動作（編集・確定など）を優先する
const INTERACTIVE_SELECTOR = "a, button, input, select, textarea, label, form"

// クリック対象がインタラクティブ要素（またはその子孫）かを判定する
export function isInteractiveTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false
  return target.closest(INTERACTIVE_SELECTOR) !== null
}

// テーブル行などをクリック可能にして詳細ページへ遷移させるコントローラ
// data-row-link-url-value で遷移先URLを指定する
export default class extends Controller {
  static values = { url: String }
  declare readonly urlValue: string

  navigate(event: MouseEvent): void {
    // 行内のリンク・ボタン（編集・確定など）のクリックは本来の動作を優先する
    if (isInteractiveTarget(event.target)) return
    if (!this.urlValue) return

    if (window.Turbo) {
      window.Turbo.visit(this.urlValue, { action: "advance" })
    } else {
      window.location.href = this.urlValue
    }
  }
}
